import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellEditorComponentBase} from "@shared/components/cell-components/cell-component";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import { MatDialog } from "@angular/material/dialog";
import {Configuration} from "@shared/models/configuration";
import {ParticleCacheService} from "@core/services/particle-cache.service";
import {Dynamic_Grid_Data_Request_Parameters} from "@shared/store/actions/virtual-grid.actions";

@Component({
    standalone: false,
    selector: 'particle-transaction-detail-cell-editor',
  templateUrl: './transaction-detail-cell-editor.component.html',
  styleUrls: ['./transaction-detail-cell-editor.component.scss']
})
export class TransactionDetailCellEditorComponent extends CellEditorComponentBase implements OnInit {

  sourceType: string;
  invalidateSubject: InvalidateSubject;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  constructor(protected dialog: MatDialog, public particleCacheService: ParticleCacheService) {
    super();
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {
    this.sourceType = this.fieldDefinition.configKey;
    const config = Configuration.getSmartGridConfig(this.sourceType);
    const caseId = this.item.cells['CaseId'].value;
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType, {'CASE_ID':caseId});
  }

}
